import React from 'react';
import { colors } from '../../constants/colors';

const SinaniumPrivacy = () => {
  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: colors.dark_blue, height: "100vh" }}>
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: colors.dark_blue, height: "100vh" }}>
        <div
          style={{
            backgroundColor: "white",
            color: "black",
            padding: "20px",
            borderRadius: "10px",
            width: "90%",
            height: "90%",
            overflowY: "scroll",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
          }}
        >
          <h1 style={{ textAlign: "center", marginBottom: "20px" }}>
            Privacy Policy for Sinanium: Galactic Dominion
          </h1>

          <p><strong>Last updated: January 08, 2026</strong></p>

          <p>
            This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.
          </p>
          <p>
            We use Your Personal data to provide and improve the Service, prevent fraudulent activities, and comply with state and federal regulations. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy.
          </p>

          <h2>Interpretation and Definitions</h2>
          <h3>Definitions</h3>
          <ul>
            <li><strong>Account</strong> means a unique account created for You to access our Service.</li>
            <li><strong>Application</strong> refers to Sinanium: Galactic Dominion, the software program provided by the Company.</li>
            <li><strong>Company</strong> refers to Eventyol, 755 International Blvd, Texas, United States.</li>
            <li><strong>Device Identifiers</strong> refers to unique IDs such as Apple's IDFA, Google Advertising ID (AAID), or Firebase Installation IDs.</li>
            <li><strong>Personal Data</strong> is any information that relates to an identified or identifiable individual.</li>
          </ul>

          <h2>Collecting and Using Your Personal Data</h2>
          <h3>Types of Data Collected</h3>

          <h4>Personal Data & Identifiers</h4>
          <p>While using Our Service, We may collect:</p>
          <ul>
            <li>Email address, First name, and Last name.</li>
            <li><strong>Device Identifiers:</strong> We explicitly collect unique device IDs to prevent "token farming" and reward abuse. This ensures that "New Account" bonuses are limited to one per physical device.</li>
            <li>Usage Data (IP address, operating system, and diagnostic logs).</li>
          </ul>

          <h4>Texas Resident Privacy (TDPSA & SCOPE Act 2026)</h4>
          <p>
            As a Texas-based entity, we comply with the Texas Data Privacy and Security Act. We use Apple’s Declared Age Range API and Google Play Age Signals to ensure age-appropriate data processing. Residents of Texas have the right to request access, correction, or deletion of their personal data, and to opt-out of targeted advertising.
          </p>

          <h3>Use of Your Personal Data</h3>
          <ul>
            <li><strong>To prevent fraud:</strong> We use your Device ID to verify device integrity and ensure "Free Token" rewards are distributed fairly.</li>
            <li><strong>To deliver targeted advertising:</strong> We work with third-party vendors (Google AdMob) to display ads tailored to your interests.</li>
            <li><strong>To manage Your Account:</strong> To provide access to game functionalities and customer support.</li>
          </ul>

          <h2>Detailed Information on Processing</h2>
          <h3>Advertising</h3>
          <p>We use Service Providers to show advertisements to help support the Service.</p>
          <ul>
            <li>
              <strong>Google AdMob:</strong> Provided by Google Inc. You may opt-out via your device settings or visit: <a href="https://support.google.com/ads/answer/2662922?hl=en" target="_blank" rel="noopener noreferrer">Google Ad Settings</a>.
            </li>
          </ul>

          <h3>Fraud Prevention & Security</h3>
          <p>
            We utilize <strong>Apple DeviceCheck</strong> and <strong>Google Play Integrity</strong>. These services allow us to identify devices that have previously engaged in reward exploitation without storing the user's permanent hardware identity in a reversible format.
          </p>

          <h2>CCPA/CPRA Privacy (California Residents)</h2>
          <p>
            <strong>Categories Collected:</strong> Identifiers (Email, Device ID, IP address) and usage data.
            We do not sell your personal information for money, but we may "share" it with advertising partners. You may opt-out by adjusting your device's privacy settings.
          </p>

          <h2>Children's Privacy</h2>
          <p>
            Our Service does not address anyone under the age of 13. For users in Texas aged 13-17, we limit data collection to essential service functions unless explicit parental consent is obtained via the platform provider.
          </p>

          <h2>Contact Us</h2>
          <p>If you have any questions about this Privacy Policy, You can contact us:</p>
          <ul>
            <li>By email: <a href="mailto:info@eventyol.org">info@eventyol.org</a></li>
            <li>By visiting: <a href="https://eventyol.org/sinanium" target="_blank" rel="noopener noreferrer">https://eventyol.org/sinanium</a></li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SinaniumPrivacy;